<template>
    <footer id="elle-footer" class="elle-footer">
        <div class="footer-top">
            <div class="grid12">
                <div class="l-col">
                    <div class="footer-about">
                        {{ nl2br(settings[0]?.footerInfo, false, false) }}
                    </div>
                    <UiRate
                        :style="'light'"
                        :rating="{
                            ratingAmount: settings[0]?.ratingAmount,
                            reviewsAmount: settings[0]?.reviewsAmount
                        }"
                    />
                </div>
                <div class="m-col">
                    <div class="page-label light">{{ $t('footer.label_menu_1') }}</div>
                    <div class="footer-menu">
                        <ul v-if="!!footerMenu.length" class="menu">
                            <li v-for="item in footerMenu" :key="item.id">
                                <NuxtLinkLocale :to="useConvertedLink(item)" :target="item.newWindow ? '_blank' : '_self'" :title="item.title">{{
                                    item.title
                                }}</NuxtLinkLocale>
                            </li>
                        </ul>
                    </div>
                    <div v-if="footerButtonLink" class="footer-buttons">
                        <UiLink :key="locale" :link="footerButtonLink" :style="'white unhover'" />
                    </div>
                </div>
                <div class="r-col">
                    <div class="page-label light">{{ $t('footer.label_menu_2') }}</div>
                    <div class="footer-menu">
                        <ul v-if="!!footerMenuInfo.length" class="menu">
                            <li v-for="item in footerMenuInfo" :key="item.id">
                                <NuxtLinkLocale :to="useConvertedLink(item)" :target="item.newWindow ? '_blank' : '_self'" :title="item.title">{{
                                    item.title
                                }}</NuxtLinkLocale>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="footer-copyright">Elle Midwives @{{ year }}</div>
            <div v-for="group in settings[0]?.footerLinks" :key="group.id" class="footer-menu-horizontal">
                <ul v-if="!!group.linksUrls.length">
                    <li v-for="(item, index) in group.linksUrls" :key="index">
                        <NuxtLinkLocale :to="useConvertedButtonLink(item)" :target="item.newWindow ? '_blank' : '_self'" :title="item.linkText">{{
                            item.linkText
                        }}</NuxtLinkLocale>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const { locale, locales } = useI18n();
const settingsData = useSettingsData();
const menuData = useMenusData();

const settings = computed<CmsItem[]>(() => settingsData.value.filter(item => item.siteId == useSiteId()));
const footerMenu = computed<CmsItem[]>(() => menuData.value.menu_footer.filter(item => item.siteId == useSiteId()));
const footerMenuInfo = computed<CmsItem[]>(() => menuData.value.menu_footer_information.filter(item => item.siteId == useSiteId()));
const activeLocaleConfig = computed(() => locales.value.find(item => item.code === locale.value));
const footerButtonLink = computed<CmsItem | null>(() => {
    const activeCraftSiteId = activeLocaleConfig.value?.craftSiteId;
    const bySiteId = activeCraftSiteId != null ? settingsData.value.find(item => Number(item.siteId) === Number(activeCraftSiteId)) : undefined;

    const byLanguage = settingsData.value.find(
        item => String(item.language ?? '').toLowerCase() === String(activeLocaleConfig.value?.language ?? '').toLowerCase()
    );

    return ((bySiteId ?? byLanguage)?.headerLinks?.[0] as CmsItem | undefined) ?? null;
});
const year = computed(() => new Date().getFullYear());
</script>
